export const percentuaisIBPT = (value: number): string => {
  const formattedNumber = (value || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formattedNumber}%`;
};
